<div class="content-container">
  <nav class="navbar navbar-expand-sm top-banner">
    <!-- Brand/logo -->
    <img src="../../assets/images/logo.png" width="80" />
    <!-- Links -->
    <ul class="navbar-nav ml-2">
      <li class="nav-item">
        <div class="contentheader">สถาบันคุ้มครองเงินฝาก (สคฝ.)</div>
        <div class="contentheader2">Deposit Protection Agency(DPA)</div>
      </li>
    </ul>
  </nav>

  <div class="news-container m-4 mt-0">
    <div class="card card-default mb-0">
      <div class="card-body">

        <div class="row mb-3" *ngIf="news.image != null">
          <div class="col-12 text-center p-0 m-0">
            <img src="{{news.image}}" class="img-fluid" style="max-width: 100%; max-height: 50vh;">
          </div>
        </div>

        <h3 class="font-cust-blue mt-3">{{news.dpa_name}}</h3>
        <br>
        <i>
          <h5>{{ news.dpa_startdate | thaidate:'short'}}</h5>
        </i>
        <hr>
        <div [innerHTML]="news.dpa_detail"></div>
        <hr>
        <div class="row">
          <div class="col-9">

            <div class="col-12">
              <h3>สถาบันคุ้มครองเงินฝาก</h3>
            </div>

            <div class="col-12">
              <label>อาคารเอสเจ อินฟินิท วัน บิสซิเนสคอมเพล็กซ์
                ชั้น 25-27 เลขที่ 349 ถนนวิภาวดีรังสิต
                แขวงจอมพล เขตจตุจักร กรุงเทพฯ 10900</label>
            </div>

          </div>

          <div class="col-3 text-right">
            <img src="../../assets/images/cc_logo.png" width="150" class="img-fluid">
          </div>

        </div>

      </div>
    </div>

    <div class="row bg-cust-blue" style="height: 5px;"></div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/news/news.component.html